import {
  EmployeeChartDataType,
  EmployeeListDataType, EmployeeMutationResponseType, PayloadChartEmployeeType, PayloadListEmployeeType, PayloadMutationEmployeeType,
} from 'components/types/employees/detail';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;

export const apiEmployee = {
  chartEmployee: 'organization/view-structure-employee',
  listEmployee: 'organization/list-employee',
  uploadFoto: 'cdn/upload',
  createEmployee: 'organization/create-employee',
  updateEmployee: 'organization/update-employee',
  importUpdateEmployee: 'organization/import-update-employee',
};

export const employeeService = {
  getEmployee: async (payload: PayloadListEmployeeType): Promise<EmployeeListDataType> => {
    const response = await http.post(`${URL}${apiEmployee.listEmployee}`, payload);

    return response.data?.data ?? response.data;
  },

  getChartEmployee: async (payload: PayloadChartEmployeeType): Promise<EmployeeChartDataType[]> => {
    const response = await http.post(`${URL}${apiEmployee.chartEmployee}`, payload);

    return response.data?.data ?? response.data;
  },

  uploadProfile: async (payload: any): Promise<any> => {
    const response = await http.post(`${URL}${apiEmployee.uploadFoto}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.getItem('token'),
      },
    });

    return response.data?.data?.directory ?? response.data?.directory;
  },

  createEmployee: async (payload: PayloadMutationEmployeeType): Promise<EmployeeMutationResponseType> => {
    const response = await http.post(`${URL}${apiEmployee.createEmployee}`, payload);

    return response.data;
  },

  updateEmployee: async (payload: PayloadMutationEmployeeType): Promise<EmployeeMutationResponseType> => {
    const response = await http.post(`${URL}${apiEmployee.updateEmployee}`, payload);

    return response.data;
  },

  importUpdateEmployee: async (payload: PayloadMutationEmployeeType): Promise<any> => {
    const response = await http.post(`${URL}${apiEmployee.importUpdateEmployee}`, payload);

    return response.data;
  },
};
